const GAME_LANUGAME = {
  251: {
    default: 'en-US',
    'en-US': {
      tips1:
        'In order to purchase the limited item, please log in to the game and then refresh this page.',
      tips2: 'Valid login period: 5:00AM Today - 4:59AM Next Day.',
    },
    'zh-TW': {
      tips1: '限購道具需要在登入遊戲後才能購買，請登入遊戲後再刷新當前頁面。',
      tips2: '登錄有效時間：當日05:00-次日04:59。',
    },
    'zh-CN': {
      tips1: '限购道具需要在登入游戏后才能购买，请登入游戏后再刷新当前页面。',
      tips2: '登录有效时间：当日05:00-次日04:59。',
    },
  },
  211: {
    default: 'en-US',
    'en-US': {
      tips1:
        'In order to purchase the limited item, please stay logged in to the game.</br>Payment Method Bonus</br>Bonus currency = Amount paid * currency rate * bonus rate</br>*Note: bonus currency will not be counted by top-up events or VIP EXP.</br>*1 Ingot = 20 KRW',
    },
    'ko-KR': {
      tips1:
        '한정 아이템은 게임 캐릭터가 온라인 상태일 때만 구매하실 수 있습니다.</br>원보 보너스 설명 :</br>원보 보너스 = 충전 금액 * 원보 환산 비율 * 보너스 비율</br>* 주의사항 : 원보 보너스는 인게임 충전 이벤트와 VIP 경험치에 포함되지 않습니다.</br>*1원보 = 한화 20원',
    },
    'zh-CN': {
      tips1:
        '限购道具需要登入游戏并保持游戏在线才能购买。</br>加码元宝说明：</br>加码元宝=付款金额*游戏元宝比例*加码比例</br>*注意：加码的元宝，不参与游戏内储值活动的计算，也不计入VIP经验</br>*1个元宝 = 20韩元',
    },
    'zh-TW': {
      tips1:
        '限購道具需要登入遊戲並保持遊戲在線才能購買。</br>加碼元寶說明：</br>加碼元寶=付款金額*遊戲元寶比例*加碼比例</br>*注意：加碼的元寶，不參與遊戲內儲值活動的計算，也不計入VIP經驗</br>*1個元寶 = 20韓元',
    },
  },
  175: {
    default: 'en-US',
    'en-US': {
      tips1:
        'In order to purchase the limited item, please log in to the game and then refresh this page.</br></br>Payment Method Bonus</br>Bonus currency = Amount paid * currency rate * bonus rate</br>*Note: bonus currency will not be counted by top-up events or VIP EXP.',
    },
  },
  255: {
    default: 'en-US',
    'en-US': {
      paypricy: 'VIP会員専用購入サイト規約',
      paypricyLink:
        `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/JpServicePrivicy/customize?keyWord=musjppayservice`,
    },
  },
  274: {
    default: 'th-TH',
    'th-TH': {
      tips1:
        'หากเป็นไอเทมที่จำกัดการซื้อ จะต้องล็อกอินเกมก่อน จึงจะซื้อได้ โปรดรีเฟรชหน้านี้หลังล็อกอินเกม.',
      tips2: 'สถานะล็อกเป็นผล:วันนี้ 05:00 น.-วันถัดไป 04:59 น.',
    },
  },
};

export const getGameLanguage = (lang, key, game) => {
  if (
    !GAME_LANUGAME[game] ||
    !GAME_LANUGAME[game].default ||
    !GAME_LANUGAME[game][GAME_LANUGAME[game].default][key]
  ) {
    return '';
  }

  let realLang =
    GAME_LANUGAME[game][lang] && GAME_LANUGAME[game][lang][key]
      ? lang
      : GAME_LANUGAME[game].default;
  return GAME_LANUGAME[game][realLang][key];
};
